<template>
  <v-container fluid style="overflow: hidden !important;">
   <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12 >
        <div class="chatboxnonselect">
          <v-layout align-center justify-center row fill-height>
            <img src='/static/img/icons/logoonechat_full.png' width="600" >
          </v-layout>
        </div>
      </v-flex>
      <DetailFriendialog
        :dialogdetailfriend="dialogdetailfriend"
        :result="result"
        :relation="relation"
        :pictureFriend="pictureFriend"
        :pictureGroup="pictureGroup"
        :status="status"
        :id="id"
        :type="type"
        @closeDialog="closeDialog">
      </DetailFriendialog>
    </v-layout>
  </v-container>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
import DetailFriendialog from '@/components/chat/dialog/manage_friend/DetailFriendDialog'

export default {
  data () {
    return {
      dialogdetailfriend: false,
      result: {},
      relation: '',
      pictureFriend: '',
      pictureGroup: '',
      status: 'loading',
      dialogshowimage_profile: false,
      pathpicture: '',
      typepathpicture: '',
      DetailFriendialog: false,
      status_login: '',
      windowWidth: '',
      tokenuser: '',
      tokenfriend: '',
      type: '',
      id: '',
      infor_user: {}
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
    if (this.$cookie.get('path_id') !== 'null' || this.$cookie.get('path_id') !== null) {
      this.id = atob(this.$cookie.get('path_id'))
      this.type = this.$cookie.get('path_type')
      this.searchfriend()
    }
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.status_login = decoded['status_login']
    if (window.innerWidth <= 960) {
      this.$router.push('/mobile/homepage')
    } else {
      this.$router.push('/chat')
    }
  },
  components: {
    DetailFriendialog
  },
  computed: {
    ...sync('*')
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage')
      } else {
        this.$router.push('/chat')
      }
    }
  },
  methods: {
    closeDialog (value) {
      this.dialogdetailfriend = value
    },
    searchfriend () {
      if (this.type === 'friend') {
        this.status = 'loading'
        this.axios.post(process.env.APImanage + '/searchtokenuser', {
          tokenuser: this.tokenuser,
          tokenfriend: this.id
        }).then((response) => {
          // console.log(response.data)
          this.status = response.data.status
          if (response.data.status === 'success') {
            this.$cookie.delete('path_type')
            this.$cookie.delete('path_id')
            this.relation = response.data.relation
            this.result = response.data.user
            if (this.result.profilepicture === '') {
              if (this.result.type === 'business') {
                this.pictureFriend = '/static/img/default_profile/business-white.png'
              } else if (this.result.type === 'bot') {
                this.pictureFriend = '/static/img/default_profile/bot-white.png'
              } else {
                this.pictureFriend = '/static/img/default_profile/man-white.png'
              }
            } else {
              this.pictureFriend = this.result.profilepicture
            }
          }
          this.dialogdetailfriend = true
        })
      } else if (this.type === 'group') {
        this.status = 'loading'
        this.axios.post(process.env.APImanage + '/getgroup', {
          tokenuser: this.tokenuser,
          group_id: this.id
        }).then((response) => {
          this.status = response.data.status
          if (response.data.status === 'success') {
            this.$cookie.delete('path_type')
            this.$cookie.delete('path_id')
            this.result = response.data.group
            if (this.result.picture === '') {
              this.pictureGroup = '/static/img/default_profile/group-white.png'
            } else {
              this.pictureGroup = this.result.picture
            }
          }
          this.dialogdetailfriend = true
        })
      }
    }
  }
}
</script>
<style type="text/css" scoped>
.container{
  padding: 0px !important;
}
.fixed-content {
    min-height:100%;
    /*position:fixed;*/
    overflow-y:scroll;
    overflow-x:hidden;
}
.content {
      padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect{
    width: 100%;
    min-width: 10vw;
    height: calc(100vh - 64px);
    background-color:white;
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/pagedefault/HomepageChat.vue